import { categories } from '@/mocks/manga';

interface CategoriesProps {
  onPickCategory: (category: string) => void;
}

const toneStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50',
  accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50',
  secondary: 'bg-secondary-100 text-secondary-900 group-hover:bg-secondary-500 group-hover:text-background-50',
};

export default function Categories({ onPickCategory }: CategoriesProps) {
  return (
    <section id="categories" className="scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-layout-grid-fill" /> 分类导航
          </span>
          <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
            按分类浏览漫画大全
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            热门、最新、人气排行应有尽有，点击分类直接进入对应作品列表，翻找更省时。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((cat) => (
            <button
              key={cat.name}
              type="button"
              onClick={() => onPickCategory(cat.name)}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl transition-colors ${toneStyles[cat.tone]}`}
              >
                <i className={cat.icon} />
              </span>
              <span className="min-w-0">
                <span className="block font-display text-base font-bold text-foreground-900">
                  {cat.name}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">
                  {cat.count} 部作品
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}